import React from 'react';

import {
  Grid,
  Box,
  Typography,
  Link,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import Logo from '../Logo';
import FeatureFlip from '../FeatureFlip';

const useStyles = makeStyles(theme => ({
  grid: {
    [theme.breakpoints.down('xs')]: {
     paddingLeft: '16px',
     paddingRight: '16px',
    }
  },
  logo: {
    marginTop: '20px',
  },
  img: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '1rem',
    },
  },
  textArea: {
    [theme.breakpoints.up('sm')]: {
      border: '1px solid #c4c4c4',
      boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.2)',
      borderRadius: '3px',
      backgroundColor: '#fff',
      padding: '1.5rem 2rem',
    },
    [theme.breakpoints.up('md')]: {
      marginRight: '33px',
    },
    [theme.breakpoints.up('lg')]: {
      marginRight: '90px',
    },
  },
  title: {
    fontWeight: 800,
    [theme.breakpoints.up('sm')]: {
      lineHeight: '1.22',
      paddingBottom: '0',
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '1rem',
    },
  },
  paragraph: {
    fontSize: '19px',
    [theme.breakpoints.up('sm')]: {
      lineHeight: '1.82 !important'
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    }
  },
  note: {
    fontSize: '17px',
    fontStyle: 'italic',
    [theme.breakpoints.up('sm')]: {
      lineHeight: '1.82 !important'
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    }
  },
  linkAnchor: {
    cursor: 'pointer',
    color: '#1973e8',
    textDecoration: 'none'
  },
  listHeader: {
    marginLeft: '-2em',
  },
}));

const Hero = ({width, partnerOrderId}) => {
  const classes = useStyles();

  return (
    <Grid className={classes.grid} item xs={12} md={6} lg={6} xl={7}>
      <Box className={classes.logo} >
        <Logo partnerOrderId={partnerOrderId} className={classes.img} />
        <Box className={classes.textArea} pt={isWidthUp('md', width) ? 6 : 0}>
          <Typography variant="h1" className={classes.title} gutterBottom={isWidthUp('md', width) ? true : false}>Book a Heating or Cooling System Checkup</Typography>
          <Typography variant="h3" className={classes.paragraph} paragraph>
            A maintenance visit from a heating, ventilation and air conditioning professional can help to diagnose any issues and keep your system in good working order.
            With preferred pricing and 24/7 customer support, all bookings are worry free!&nbsp;
            <FeatureFlip feature="coschedulingPriceUpdateEnabled"
                         on={ <b>HVAC visits are just $89.</b> }
                         off={ <b>For a limited time standard visits are just $49.</b> } />
          </Typography>
          <FeatureFlip feature="coSchedulingEnabled"
                       on={
                         <Typography variant="h3" className={classes.paragraph}>
                           <ul>
                             <span className={classes.listHeader}><b>Here&apos;s how it works:</b></span>
                             <li>Select a preferred date and time</li>
                             <li>A Nest Technician will reach out within a 24-hour window to review availability and confirm your appointment date and time window</li>
                             <li>Please note that it is not a guaranteed date and time, but we will do our best to meet your preference</li>
                           </ul>
                         </Typography>
                       } />
          <Typography variant="h3" className={classes.note} paragraph>
            Note: This appointment is for your HVAC system. It does not include fixing or installing the Nest thermostat itself.
            <FeatureFlip
              feature="coSchedulingEnabled"
              off={
                    <>
                      &nbsp;For any inquiries related directly to a Nest thermostat, please use <Link target="_blank" href="https://store.google.com/magazine/installation">this link</Link> to set up an installation service.
                    </>
                   }
            />
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};

export default withWidth()(Hero);
